module.exports = __webpack_public_path__ + "static/img/record_arrow.f5e15afa.svg";